import { Space } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { BodyShort01 } from 'components/styles';
import { useTranslate } from 'hooks/use-translation';

const DisabledText = styled.div`
  ${BodyShort01};
  font-weight: var(--font-weight-normal);
  color: var(--gray-90);
  opacity: 0.7;
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
  cursor: not-allowed;
`;

export const DisabledTemplateFilter: FC = () => {
  const translate = useTranslate();

  return (
    <Space size={4}>
      <DisabledText>
        {translate('reports.template_insight.template_picker.title')}:
        <strong>
          {translate('reports.template_insight.filter.all_template')}
        </strong>
      </DisabledText>
    </Space>
  );
};
